




































































































import { Component, Prop, Inject, Vue } from 'vue-property-decorator'
// Common
import NotFound from '@/components/common/NotFound.vue'
import OutdoorSettingButton from './OutdoorSettingButton.vue'
import IndoorSettingButton from './IndoorSettingButton.vue'

@Component({
  components: {
    NotFound,
    OutdoorSettingButton,
    IndoorSettingButton,
  },
})
export default class FloorBuildingFilterFrom extends Vue {
  @Prop()
  parent!: any

  @Prop()
  buttonSettingMode!: string

  @Inject('is-observer')
  isReadOnly!: () => boolean
}
